
import { Component,Prop,Watch, BaseMixins } from '@/lib';

@Component
export default class Fullscreen extends BaseMixins {
    @Prop({type:Boolean,default:false}) value:boolean;

    get showFullScreenBtn () {
      return window.navigator.userAgent.indexOf('MSIE') < 0
    }

    handleFullscreen () {
      let doc = document as any;
      if (this.value) {
        if (doc.exitFullscreen) {
          doc.exitFullscreen()
        } else if (doc.mozCancelFullScreen) {
          doc.mozCancelFullScreen()
        } else if (doc.webkitCancelFullScreen) {
          doc.webkitCancelFullScreen()
        } else if (doc.msExitFullscreen) {
          doc.msExitFullscreen()
        }
      } else {
        if (doc.body.requestFullscreen) {
          doc.body.requestFullscreen()
        } else if (doc.body.mozRequestFullScreen) {
          doc.body.mozRequestFullScreen()
        } else if (doc.body.webkitRequestFullScreen) {
          doc.body.webkitRequestFullScreen()
        } else if (doc.body.msRequestFullscreen) {
          doc.body.msRequestFullscreen()
        }
      }
    }
    handleChange () {
      this.handleFullscreen()
    }

    mounted () {
       let doc= document as any;

        let isFullscreen = doc.fullscreenElement || doc.mozFullScreenElement || doc.webkitFullscreenElement || doc.fullScreen || doc.mozFullScreen || doc.webkitIsFullScreen
        isFullscreen = !!isFullscreen
        doc.addEventListener('fullscreenchange', () => {
            this.$emit('input', !this.value)
            this.$emit('on-change', !this.value)
        })
        doc.addEventListener('mozfullscreenchange', () => {
            this.$emit('input', !this.value)
            this.$emit('on-change', !this.value)
        })
        doc.addEventListener('webkitfullscreenchange', () => {
            this.$emit('input', !this.value)
            this.$emit('on-change', !this.value)
        })
        doc.addEventListener('msfullscreenchange', () => {
            this.$emit('input', !this.value)
            this.$emit('on-change', !this.value)
        })
        this.$emit('input', isFullscreen)
    }
}
